module.exports = __webpack_public_path__ + "static/img/incentiveImg.4a0c66f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DiwaliFestival/incentiveImg.svg
// module id = Guhs
// module chunks = 0